import { useStorage } from '@vueuse/core'
import { ref, computed, ComputedRef } from 'vue'

const filterStorage = useStorage('filters', {}, sessionStorage)

export const useFiltersStorage = <TFilters extends unknown>(
    filtersName: string | undefined,
): {
    updateFilterStorage: (filters: Record<string, unknown>) => void
    clearFilterStorage: () => void
    currentFilters: ComputedRef<TFilters>
} => {
    const _filtersName_ = ref<string | undefined>(filtersName)

    const updateFilterStorage = (filters: Record<string, unknown>): void => {
        if (_filtersName_.value) {
            Object.assign(filterStorage.value, {
                [_filtersName_.value]: filters,
            })
        }
    }

    const clearFilterStorage = (): void => {
        if (_filtersName_.value) {
            Object.assign(filterStorage.value, {
                [_filtersName_.value]: {},
            })
        }
    }

    return {
        updateFilterStorage,
        clearFilterStorage,
        currentFilters: computed<TFilters>(
            (): TFilters => {
                if (_filtersName_.value) {
                    return (filterStorage.value as Record<string, unknown>)[
                        _filtersName_.value
                    ] as TFilters
                }
                return {} as TFilters
            },
        ),
    }
}
